export default ($t) => ({
  title: "PreCampaignTeamEvent",
  type: "object",
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      extended: true,
      default: false,
    },
    autoplay_delay: {
      title: $t(
        "edit_campaign.schema_pre_campaign_team_event_autoplay_delay",
        "Slides autoplay delay"
      ),
      type: "number",
      default: 0,
      description: $t("edit_campaign.schema_pre_campaign_team_event_autoplay_delay_description", {
        returnEmptyOnMissing: true,
      }),
    },
    one_column_team_limit: {
      title: $t("edit_campaign.schema_one_column_team_limit", "One column team limit"),
      type: "number",
      default: 10,
      description: $t(
        "edit_campaign.schema_pre_campaign_team_event_one_column_team_limit_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
    },
  },
});
